import { mapFrom } from 'utils/functional'
import KEY_CODES from 'constants/keyCodes'

export const DISABLED_KEY_CODES = new Set([
  KEY_CODES.END,
  KEY_CODES.HOME,
  KEY_CODES.LEFT_ARROW,
  KEY_CODES.UP_ARROW,
  KEY_CODES.RIGHT_ARROW,
  KEY_CODES.DOWN_ARROW,
])

export const TIMER_MASK_CHAR = '0'

export const TIMER_MASK_HMMSSS = '9:99:99.9'
export const TIMER_MASK_MSS = '9:99'

export const TIMER_HMMSSS_MAX_SECONDS = 6553.4
export const TIMER_MSS_MAX_SECONDS = 240

export const timerMaxSeconds = mapFrom({
  [TIMER_MASK_HMMSSS]: TIMER_HMMSSS_MAX_SECONDS,
  [TIMER_MASK_MSS]: TIMER_MSS_MAX_SECONDS,
})

// substrings to pull from date isostring
export const timerSubstRange = mapFrom({
  [TIMER_MASK_HMMSSS]: [12, 9],
  [TIMER_MASK_MSS]: [15, 4],
})
